import { useEffect } from 'react';

// This hack is needed to circumvent an issue with the Android version of the native app.
// Our native app explicity adds a 'swipe-down = refresh the page' behavior
// if the body is scrolled to the top. This means that attempting to scroll up
// on anything, even scrollable regions, will not work if the body is at the top.
// Solution: When needed, force scrolls window.top down 1px if it was at the top.
// Note: Targets window.top in case chat has been iframed.

/**
 * @param active Whether the effect should be applied
 */
export const useDisallowScrollToTop = (active?: boolean): void => {
  useEffect(() => {
    if (!active) {
      return;
    }

    const handleScroll = (): void => {
      if (window.top?.scrollY === 0) {
        window.top?.scrollTo(0, 1);
      }
    };
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [active]);
};
